import React from "react";
import "./EcoTec.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";


class EcoTec extends React.Component {
    render() {
        return (
            <div>
                <Nav/>
                <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Project">01 Master Plan</a></p>
              <p className="ab">Planning Structure</p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/PlanningFeatures">Planning Features</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Intro"> 02 Project Introduction</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoTec">03 Eco Technologies</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">04 Project Location</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoVision">05 Eco-Vision</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="abhead7">
        <p></p>
        </div>
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Proposed Projects Implementation Eco Technologies</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>Overall Project Presentation</p>
        <p className="text-justify">The Negative Carbon Living Lab (NCLL) will be developed by Good Morning Bamboo Agro-Forestry and Investment Services (Good Morning Bamboo) with the support of other partners, including the Good Morning Bamboo Eco-City Administrative Committee (GMBAC). The primary goal of this project is to showcase and promote both Singapore and Ghana’s best practices in the development of sustainable design strategies and green building technologies. As an experimental and interactive green building, LCLL serves as a ‘living laboratory’ that operates as a Research and Disruptive Innovative Development (R&DID) space, whilst simultaneously demonstrates unique low carbon design features.

</p>
<div class="card mb-3" style={{maxWidth: "540px;"}}>
  <div class="row no-gutters">
    <div class="col-md-4">
      <img src="https://i.imgur.com/HhT5lbE.jpg" class="card-img" alt="..."/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <p class="card-text">Site Area: 600 ㎡
Gross Floor Area: 200 ㎡
Building Heigh: 6.3 m
Number of Floors:
2 storeys with a basement carpark
Construction Period:
2018– 2019
</p>
      </div>
    </div>
  </div>
</div>
<h3  style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">Achievements</h3>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
<ul>
    <li><span style={{fontWeight: 'bold'}}>High Renewable Energy Utilization</span><br/>
90% of energy derived from renewable sources.
</li><br/>
<li><span style={{fontWeight: 'bold'}}>Optimal Energy Efficiency</span><br/>
50% less energy consumed compared to similar buildings in Cape Coast, which is equivalent to 171 tons of coal and 427 tons of carbon dioxide.
</li>
<li><span style={{fontWeight: 'bold'}}>Creative Use of Recylable Materials</span><br/>
30% recyclable materials used, which is 3 times the requirement of Eco-City’s Green Building Evaluation Standard.
</li>
<li><span style={{fontWeight: 'bold'}}>Efficient Water Savings</span><br/>
50% non-traditional water used and 80% rain water not discharged into public sewers.
</li>
</ul>
    <h3 style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">Ten (10) Eco-Technology Features</h3>
    <hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
    <div className="ml-5">
    <img  src="https://i.imgur.com/1gh2Pir.jpg" alt="..."/>
    <div class="card mb-3 mt-5" style={{maxWidth: "540px;"}}>
  <div class="row no-gutters">
    <div class="col-md-6">
      <img  src="https://i.imgur.com/DeEmwYF.jpg" class="card-img" alt="..."/>
    </div>
    <div class="col-md-6">
      <div class="card-body">
        <p class="card-text"><span style={{fontWeight: 'bold'}}>Where Environment Shape Building</span> – Climate-Oriented Design<br/>
        <span style={{fontWeight: 'bold'}}>Optimal building shape, size and orientation</span>– creates ideal external micro-climate.<br/>
        <span style={{fontWeight: 'bold'}}>Minimal Northern facade openings</span>– reduces heat loss and exposure to cold Northern winds.<br/>
        <span style={{fontWeight: 'bold'}}>Maximum glass and windows on South facade</span>– increases internal solar heat gain in winter.<br/>
        <span style={{fontWeight: 'bold'}}>Designed for natural air flow</span>– integrated passive design promotes natural ventilation and reduces total yearly energy consumption by 2%.<br/>
</p>
      </div>
    </div>
  </div>
</div>
<div className="ml-5">
    <img src="https://i.imgur.com/SY0c2Gf.jpg" alt="..."/>
</div>
<h3  style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">Experience Natural Daylighting</h3>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
<p>Large skylights and windows in the South facade and solar pipes at the basement car park – brings maximum daylight into the building.
Sun shading devices and light-shelves – directs daylight inwards by reflection and reduces heat transmittance.
</p>
<div className="ml-5">
    <img src="https://i.imgur.com/1OYifjG.jpg" alt="..."/>
</div>
<p  style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">Building’s Adaptive “Skin” - High Performance Envelope</p>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
<div className="ml-5">
    <img src="https://i.imgur.com/ees250t.jpg" alt="..."/>
</div>
        </div>
       </div>
       <p  style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">Building’s Circulatory System – Water-Saving Measures</p>
       <div class="card mb-3 mt-5" style={{maxWidth: "540px;"}}>
  <div class="row no-gutters">
    <div class="col-md-6">
      <img  src="https://i.imgur.com/ChqciA1.jpg" class="card-img" alt="..."/>
    </div>
    <div class="col-md-6">
      <div class="card-body">
        <p class="card-text"><span style={{fontWeight: 'bold'}}>Efficient water-saving sanitary fixtures </span>  – water-saving efficiency is 40% higher than requirement of Eco-City’s Green Building Evaluation Standard<br/>
        <span style={{fontWeight: 'bold'}}>Rain water harvesting and reuse </span>– collected rain water meets 5% of annual water demand.<br/>
        <span style={{fontWeight: 'bold'}}>The volume of recycled water or potable water saved is equivalent to 4 Olympic </span> – sized swimming pools per year.<br/>
        <span style={{fontWeight: 'bold'}}>Water usage monitoring </span>– achieved through use of sub-metering and leak detection systems.<br/>
</p>
      </div>
    </div>
  </div>
</div>
        <div className="mt-5 ml-5">
            <img src="https://i.imgur.com/zmhWvag.jpg" alt="..."/>
        </div>
        <p  style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">Pulse of Building – Energy Efficient M&E Services and Renewable Energy Systems</p>
    <hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
    <p className="text-center mt-2"><span style={{fontWeight: 'bold'}}>Exhaust heat recovery system</span>– achieves annual savings of 4% energy consumption which can support the annual electricity demand of around 30 households.
    <br/><br/><span style={{fontWeight: 'bold'}}>Renewable Energy Systems</span>– contributes to 60% of annual heating/cooling and domestic hot water demand of the building, as well as 12% of annual electricity demand.
</p>
<div className="ml-5 mt-3">
    <img src="https://i.imgur.com/sSg7yMO.jpg" alt="..."/>
</div>
<p  style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">The Building Breathes – Air Purification Technologies</p>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
<p><span style={{fontWeight: 'bold'}}>Central fresh air system with high efficiency air filter </span>– removes PM 2.5 by more than 90%.
<br/><br/><span style={{fontWeight: 'bold'}}>CO2 sensors at critical locations </span>– monitors and maintains ideal indoor air quality.
</p>
<div className="ml-5 mt-5">
    <img src="https://i.imgur.com/3bO2UBS.jpg" alt="..."/>
</div>
<p  style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">Creative Building Blocks – Use of Environmentally Friendly Material</p>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
    <p>30% of the building materials, including steel and concrete blocks, are recyclable, which is 3 times the requirement of the Eco-City’s Green Building Evaluation Standards.<br/>
    <span style={{fontWeight: 'bold'}}>Extensive use of construction recyclables </span>– paving stones on the roof garden are made of construction waste materials.
    </p>
    <div className="ml-5 mt-3">
        <img src="https://i.imgur.com/eHwY8so.jpg" alt="..."/>
    </div>
    <p  style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">Intelligent Building Management Systems</p>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
<p><span style={{fontWeight: 'bold'}}>Building Automation System</span> – serves as a “brain” which improves the operational efficiency and optimizes building performance.
<br/><span style={{fontWeight: 'bold'}}>Energy Management System and Energy Wall</span> – serve as “sensors” which monitor the building’s operational efficiency.
</p><br/>
<div className="ml-5 mt-3">
        <img src="https://i.imgur.com/ILxSg4o.jpg" alt="..."/>
    </div>
    <p  style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">Life-circle Maintenance “Health Check” Green Building Operation</p>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
<p><span style={{fontWeight: 'bold'}}>Green Facilities Management teams </span>– implement green building maintenance practices throughout building’s lifecycle.
<br/><span style={{fontWeight: 'bold'}}>Green Building Operation Guideline </span> – shapes building user behaviors and raises awareness for resource conservation.
</p><br/>
<div className="ml-5 mt-3">
        <img src="https://i.imgur.com/gGJx0oI.jpg" alt="..."/>
    </div>
    <p  style={{fontWeight: 'bold', color: 'green'}} className="text-center mt-5">Green Lung – Vertical Greenery Systems</p>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-50 m-auto"/>
<p className="text-center"><span style={{fontWeight: 'bold'}}>Green roof  </span>– reduces heat transfer into the building and creates a cooler micro-climate.
<br/><span style={{fontWeight: 'bold'}}>Indoor garden and green wall  </span> – filters indoor air and creates a vibrant indoor space
</p><br/>
<div className="ml-5 mt-3">
        <img src="https://i.imgur.com/6phXNic.jpg" alt="..."/>
    </div>
     </div>
   </div>
            </div>
        )
    }
}
export default withRouter(EcoTec);